module.exports = __webpack_public_path__ + "img/11.e08e7e36.jpg";